import { engagementRateFollowersConfig } from '@/lib/analytics/kpis/facebook/engagementRateFollowers';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const engagementRateFollowersMVConfig = {
    ...engagementRateFollowersConfig,
    name: 'kpi.facebook.engagement_rate_followers',
    tooltip: null,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
